module.exports = __webpack_public_path__ + "static/progetto_panoramicalliving1-1058ac1bda7b47b6581e1314bd9fb190.jpg";